export default (device) => {
  const defaultGroup = JSON.parse(device.groups[0] || "{}");
  const group = defaultGroup.type;
  const familyName = defaultGroup.familyName;
  const jid = device.jid._local;
  return {
    jid,
    group,
    familyName,
    name: device.name
  };
};
